import { DietaryRequirements } from "@/clients/models/DietaryRequirements";
import { QueryKeys } from "@/constants/query-keys";
import { useGetDietaryRequirement } from "@/hooks/requests/dietary-requirement/use-get-dietary-requirement";
import { useGetDietaryRequirementOptions } from "@/hooks/requests/dietary-requirement/use-get-dietary-requirement-options";
import { useUpdateDietaryRequirement } from "@/hooks/requests/dietary-requirement/use-update-dietary-requirement";
import { useToast } from "@/hooks/ui/use-toast";
import { setProfileContext } from "@/utils/sentry/tools";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";

export const useDietaryRequirement = (onSuccess: () => void) => {
  const queryClient = useQueryClient();
  const { dietaryOptions, isLoading: isLoadingOptions } =
    useGetDietaryRequirementOptions();
  const { dietaryRequirement } = useGetDietaryRequirement();
  const { updateDietaryRequirement, isUpdating } =
    useUpdateDietaryRequirement();
  const { showError } = useToast();
  const [selectedDietary, setSelectedDietary] = useState<Set<string>>(
    new Set(),
  );

  useEffect(() => {
    console.log("dietaryRequirement", dietaryRequirement);
    if (dietaryOptions && dietaryRequirement) {
      const selectedDietaryOptions = dietaryOptions.filter((option) =>
        dietaryRequirement.dietaryOptions?.includes(option),
      );
      setSelectedDietary(new Set(selectedDietaryOptions));
    }
  }, [dietaryRequirement]);
  console.log("selectedDietary", selectedDietary);

  const handleSubmit = () => {
    const dataBody: DietaryRequirements = {
      dietaryOptions: Array.from(selectedDietary),
    };

    updateDietaryRequirement(dataBody, {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QueryKeys.DIETARY_REQUIREMENT],
        });
        setProfileContext(QueryKeys.DIETARY_REQUIREMENT, dataBody);
        onSuccess();
      },
      onError: (error) => {
        showError(error.message);
      },
    });
  };
  return {
    dietaryOptions,
    isLoadingOptions,
    selectedDietary,
    setSelectedDietary,
    handleSubmit,
    isUpdating,
  };
};
